import * as React from "react";
import { Overlay, Tooltip } from "react-bootstrap";
import useGeneratedId from "../../../hooks/useGeneratedId";
import { ReactNode } from "react";
import classNames from "classnames";

type Props = {
	className?: string;
	label?: ReactNode
	placement?: "top" | "left" | "bottom" | "right"
};

export default (props => {
	const { className } = props;
	const [showTooltip, setShowTooltip] = React.useState(false);
	const [showTooltipOverride, setShowTooltipOverride] = React.useState(false);

	const id = useGeneratedId("tooltip");

	// NOT STATE! This should update without refresh
	let awaitingShowTooltip = false;

	const tooltip = (
		<Tooltip
			id={id}
			className="tooltip"
			onMouseEnter={() => setShowTooltipOverride(true)}
			onMouseLeave={() => setShowTooltipOverride(false)}
		>
			<button aria-label="Close" className="tooltip-close" onClick={ev => { setShowTooltip(false); setShowTooltipOverride(false); ev.stopPropagation(); }} >&#x2716;</button>
			<div>{props.children}</div>
		</Tooltip>
	);

	const ref = React.useRef<HTMLSpanElement>(null);

	return (
		<>
			<span
				ref={ref}
				className={classNames(className, props.label ? "tooltip-trigger-label-only" : "tooltip-trigger")}
				tabIndex={0}
				aria-label="information"
				onClick={props.label ? () => { } : ev => ev.stopPropagation()}
				onMouseEnter={() => {
					awaitingShowTooltip = true;
					setTimeout(() => setShowTooltip(awaitingShowTooltip), 200);
				}}
				onFocus={props.label ? () => {
					awaitingShowTooltip = true;
					setTimeout(() => setShowTooltip(awaitingShowTooltip), 200);
				} : () => { }}
				onMouseLeave={() => {
					awaitingShowTooltip = false;
					setShowTooltip(false);
				}}
				onBlur={props.label ? () => {
					awaitingShowTooltip = false;
					setShowTooltip(false);
				} : () => { }}
			>
				{props.label ? props.label : <>&#8505;</> /* information symbol */}
			</span>

			<Overlay
				show={showTooltip || showTooltipOverride}
				onHide={() => setShowTooltip(false)}
				placement={props.placement ?? "right"}
				target={ref.current}
			>
				{tooltip}
			</Overlay>
		</>
	);
}) as React.FC<Props>;
